import React from "react";
import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles({
//   root: ` color:white;
//   background:black;
//   font-size: calc(10px + 2vmin);
//   padding : 14px;
//   text-align: center;`,
//   "@media screen and (min-width:600px)": {
//     root: ` color:white;
//     background:black;
//     font-size: calc(10px + 2vmin);
//     margin : 20px auto;
//     text-align: center;
//     `,
//   },
// });

const useStyles = makeStyles({
  root: {
    color: "white",
    background: "black",
    fontSize: "calc(10px + 2vmin)",
    height: "calc(100% - 74% - 14%)",
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
  },
});
function Footer() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      © 2020 Shinwon corp. <br />
      All Rights Reserved
    </div>
  );
}

export default Footer;
